import { Component, Input, EventEmitter, Output, OnInit, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
  HttpService,
  TokenService,
  AuthService
} from 'src/app/services';

import { environment as env } from 'src/environments/environment';
import { Subscription } from 'rxjs/internal/Subscription';
import { Report } from 'src/app/models';

@Component({
  selector: 'cm-report-dialog',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.css']
})
export class ReportComponent implements OnInit {
  @Input() visible: boolean = false;
  @Output() close: EventEmitter<void> = new EventEmitter();

  protected language: string | null;
  private language$: Subscription | null;


  report: Report | null = null;

  dateList: string[] = [];
  providerList: string[] = [];

  startDate: string = '';
  endDate: string = '';
  payrollStatus: string = '';
  selectedProvider: string = '';
  provider : string = '';
  current_page: number = 1;
  pageSize = 10;

  totalBetAmt: number = 0;
  totalValidBet: number = 0;
  totalWlAmt: number = 0;
  totalCurrentPageItems: number = 0;

  activeTab: string = 'tDay'; // Default active tab


  constructor(
    private http: HttpService,
    private token: TokenService,
    private translate: TranslateService,
    private auth: AuthService
  ) {
    this.language = '';
    this.language$ = null;
  }

  onClose(): void {
    this.close.emit();
  }

  ngOnInit() {
    this.language = this.token.getLocalToken(env.TokenKeys.LanguageToken);

    this.language$ = this.translate.onLangChange.subscribe((value: any) => {
      this.language = value.lang;
    });

    this.generateDates();
    this.startDate = this.dateList[0];
    this.endDate = this.dateList[0];

    if (this.visible) {
      this.getReport();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['visible'] && changes['visible'].currentValue === true) {
      this.getReport();
    }
  }

  generateDates(): void {
    const today = new Date();
    const daysBefore = 14;

    // Generate dates from 14 days before today to today
    for (let i = -daysBefore; i <= 0; i++) {
      const date = new Date(today);
      date.setDate(today.getDate() + i);
      this.dateList.push(this.formatDate(date));
    }

    // Sort dates in descending order
    this.dateList.sort((a, b) => new Date(b).getTime() - new Date(a).getTime());
  }

  formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  getReport() {
    // const userProfile = this.auth.getUserProfile();

    const payload: any = {
      CurrentCulture: this.language,
      // AcctUserId: userProfile.AcctUserId,
      UserRoleId: 0,
      // LoggedInAcctUserId: userProfile.AcctUserId,
      // IpAddress: userProfile.IpAddress,
      UserAgent: null,
      Country: null,
      PageNumber: this.current_page,
      PageSize: this.pageSize,
      SortBy: 0,
      SortDirection: 1,
      TicketStatus: this.payrollStatus,
      DateFrom: this.startDate + ' 00:00:00',
      DateTo: this.endDate + ' 23:59:59',
      // CurrentAcctId: userProfile.AcctId,
      ProviderIds: this.provider,
      Currency: "MYR"
    }

    this.http
      .post('report', 'getmemberbetdetailslist', payload)
      .subscribe((resp: Report) => {
        if (resp && resp.Code == 1) {
          this.report = resp;       
          
          this.totalBetAmt = this.report.Records.reduce((sum: number, record: any) => sum + record.BetAmt, 0);
          this.totalValidBet = this.report.Records.reduce((sum: number, record: any) => sum + record.ValidBet, 0);
          this.totalWlAmt = this.report.Records.reduce((sum: number, record: any) => sum + record.WlAmt, 0);
          this.totalCurrentPageItems = this.report.Records.length;

          // Translate ticket status
          this.report.Records.forEach(record => {
            if(record.ProviderCode == 'CTC'){
              this.translate.get('contents.report.provider.ctc').subscribe((text: string) => {
                record.ProviderName = text;
              });
            } else if (record.ProviderCode == 'BGC') {
              this.translate.get('contents.report.provider.bgc').subscribe((text: string) => {
                record.ProviderName = text;
              });
            } else if (record.ProviderCode == 'WIC') {
              this.translate.get('contents.report.provider.wic').subscribe((text: string) => {
                record.ProviderName = text;
              });
            } else if (record.ProviderCode == 'GMPGS') {
              this.translate.get('contents.report.provider.gmpgs').subscribe((text: string) => {
                record.ProviderName = text;
              });
            } else if (record.ProviderCode == 'GMPPS') {
              this.translate.get('contents.report.provider.gmpps').subscribe((text: string) => {
                record.ProviderName = text;
              });
            } else if (record.ProviderCode == "DGC") {
              this.translate.get('contents.report.provider.dgc').subscribe((text: string) => {
                record.ProviderName = text;
              });
            }

            if (record.TicketStatus === 'Settled') {
              this.translate.get('contents.report.settled').subscribe((text: string) => {
                record.TicketStatus = text;
              });
            } else if (record.TicketStatus === 'Unsettled') {
              this.translate.get('contents.report.unsettlement').subscribe((text: string) => {
                record.TicketStatus = text;
              });
            } else {
              this.translate.get('contents.report.revoked').subscribe((text: string) => {
                record.TicketStatus = text;
              });
            }
          });
        } 
      });
  }


  skip(pageNumber: string): void {
    const parsedPageNumber = parseInt(pageNumber, 10);

    if (isNaN(parsedPageNumber) || parsedPageNumber < 1 || parsedPageNumber >= (this.report?.Pagination?.TotalPages ?? 1) || parsedPageNumber == this.current_page) {
      return;  // Exit the function early if the pageumber is invalid
    }

    this.current_page = parsedPageNumber;
    this.getReport();
  }

  filp(number: number) {
    let tmp_current_page = this.current_page + number;
    let totalPage = this.report?.Pagination?.TotalPages ?? 1;

    if(tmp_current_page < 1){
      tmp_current_page = 1;
    } else if(tmp_current_page > totalPage) {
      tmp_current_page = totalPage;
    } else {
      this.current_page += number;
      this.getReport();
    }
  }

  setToday(): void {
    this.startDate = this.dateList[0];
    this.endDate = this.dateList[0];
    this.activeTab = 'tDay';

    this.resetCurrentPage();
    this.getReport();
  }

  setYesterday(): void {
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    this.startDate = this.formatDate(yesterday);
    this.endDate = this.formatDate(yesterday);
    this.activeTab = 'yDay';

    this.resetCurrentPage();
    this.getReport();
  }

  setLast7Days(): void {
    const today = new Date();
    const startOfLast7Days = new Date(today);
    startOfLast7Days.setDate(today.getDate() - 7);
    this.startDate = this.formatDate(startOfLast7Days);
    this.endDate = this.formatDate(today);
    this.activeTab = 'tWeek';

    this.resetCurrentPage();
    this.getReport();
  }

  onSearch()
  {
    this.resetCurrentPage();
    this.getReport();
  }

  resetCurrentPage() {
    this.current_page = 1;
  }
}
